import chartLoader from '../../../images/predict_chart/PTC.png';
import bonus from '../../../images/music_match/Bonus.png';
import newMusic from '../../../images/music_match/new_music.png';
import videoDrop from '../../../images/music_match/video_drop.png';
import Matchup from '../../../images/music_match/Match-Up.png';

export const animationData = {
    predictChart: chartLoader,
    MusicMatch: Matchup,
    currentMusic: newMusic,
    newMusic: newMusic,
    videoDrop: videoDrop,
    bonus: bonus
}